export default __webpack_public_path__ + "static/media/BlueContact.bade4de1.svg";